var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogofull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.74 184.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff004f;}.cls-2{fill:#059b5c;}.cls-3{fill:#272727;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.55,
    y: 69.18,
    width: 27.87,
    height: 27.87
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.61,
    y: 71.86,
    width: 27.87,
    height: 27.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.61,
    y: 104.97,
    width: 27.87,
    height: 27.87
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.45,
    y: 104.97,
    width: 27.87,
    height: 27.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.71,
    y: 138.74,
    width: 29.73,
    height: 29.73
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.68,
    y: 102.53,
    width: 21.42,
    height: 21.42
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.09,
    y: 128.66,
    width: 25.87,
    height: 25.87
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.16,
    y: 78.92,
    width: 18.13,
    height: 18.13
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.74,
    y: 87.99,
    width: 14.39,
    height: 14.39
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.02,
    y: 62.97,
    width: 10.15,
    height: 10.15
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.86,
    y: 133.66,
    width: 10.15,
    height: 10.15
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.93,
    y: 112.41,
    width: 13,
    height: 13
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 104.63,
    width: 12.85,
    height: 12.85
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.52,
    y: 159.24,
    width: 11.29,
    height: 11.29
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.1,
    y: 87.99,
    width: 10.65,
    height: 10.65
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.9,
    y: 173.92,
    width: 10.65,
    height: 10.65
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.23,
    y: 172.95,
    width: 8.97,
    height: 8.97
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.19,
    y: 140.1,
    width: 21.11,
    height: 21.11
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.09,
    y: 165.21,
    width: 10.65,
    height: 10.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.22,27.79A40.47,40.47,0,1,1,33.65,20,40.33,40.33,0,0,1,60.78,34.33,42.45,42.45,0,0,1,76.24,0a42.48,42.48,0,0,1,8.62,36.64A40.34,40.34,0,0,1,114.22,27.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.94,64.39h10.9V88.55c1.54-4.45,7.08-7.63,14.62-7.63a21.43,21.43,0,0,1,16.26,6.9,23.24,23.24,0,0,1,6.63,17,23.58,23.58,0,0,1-6.63,17.08,21.67,21.67,0,0,1-16.26,6.81c-7.54,0-13.08-3.18-14.62-7.63v6.63h-10.9Zm33.69,50.41a14.72,14.72,0,0,0,0-20,12.78,12.78,0,0,0-9.62-4,13.92,13.92,0,0,0-10,4,14.5,14.5,0,0,0,0,20,13.92,13.92,0,0,0,10,4A12.78,12.78,0,0,0,184.63,114.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.89,104.81c0-7.27,2.27-13.08,6.72-17.53s10.27-6.63,17.26-6.63c6.63,0,12.08,2.18,16.26,6.63a22.75,22.75,0,0,1,6.36,16.44c0,1.36-.09,2.64-.18,3.82H215.7c.36,7.26,5.72,12,13.81,12a16.85,16.85,0,0,0,12.35-5.27l6.54,6.36a25.39,25.39,0,0,1-19.26,8.17c-7.17,0-13.08-2.18-17.53-6.45s-6.72-10-6.72-17.17Zm35.52-4.9a8.91,8.91,0,0,0-3.45-7,11.73,11.73,0,0,0-8.09-3,14.06,14.06,0,0,0-8.81,2.91A10,10,0,0,0,216,99.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.76,127.7V81.92h10.81v6.81c2.18-4.81,7.17-7.72,13.62-7.72a17.1,17.1,0,0,1,3.27.27V91.82a23.43,23.43,0,0,0-4.54-.45c-7.54,0-12.35,4.72-12.35,12.26V127.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.18,127.7V81.92H305v6.81c2.18-4.81,7.18-7.72,13.63-7.72a17.1,17.1,0,0,1,3.27.27V91.82a23.51,23.51,0,0,0-4.54-.45c-7.54,0-12.36,4.72-12.36,12.26V127.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.34,136.88a16.38,16.38,0,0,0,5.08.72,7.18,7.18,0,0,0,4-1,7.85,7.85,0,0,0,2.63-3.9l1.18-3.27L325.07,81.92h11l13.44,34.52,12.63-34.52h11l-20.53,53.23a23.22,23.22,0,0,1-4.9,8.17c-2.73,2.55-6.36,3.82-11,3.82a18.88,18.88,0,0,1-5.36-.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.75,64.39h10.9v48.32c0,4.45,1.46,6.36,5.45,6.36a11.67,11.67,0,0,0,3.27-.36v9.72a19.68,19.68,0,0,1-5.17.54c-9.63,0-14.45-4.9-14.45-14.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.25,88.55V81.92h10.9v32c0,3.91-5.09,5.36-2.64,5.36a8.49,8.49,0,0,0,1.27-.18l-3,.81c-1.18.46,2,.73-.36.73-2.63,0,.28.55-1.36-.45-2-1.37-3.27,3.82-3.72,1.46-3.18,4.81-8.45,7.17-15.72,7.17a21.76,21.76,0,0,1-16.35-6.9,23.89,23.89,0,0,1-6.54-17.08,23.54,23.54,0,0,1,6.54-17,21.76,21.76,0,0,1,16.35-6.9C432,80.92,437.52,84.19,439.25,88.55ZM436,114.8a14.25,14.25,0,0,0,0-20,13.56,13.56,0,0,0-9.9-4,13.12,13.12,0,0,0-9.72,4,15,15,0,0,0,0,20,13.12,13.12,0,0,0,9.72,4A13.56,13.56,0,0,0,436,114.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.32,64.39h10.9V88.55c1.54-4.45,7.09-7.63,14.62-7.63a21.43,21.43,0,0,1,16.26,6.9,23.21,23.21,0,0,1,6.64,17,23.55,23.55,0,0,1-6.64,17.08,21.67,21.67,0,0,1-16.26,6.81c-7.53,0-13.08-3.18-14.62-7.63v6.63h-10.9ZM492,114.8a14.72,14.72,0,0,0,0-20,12.78,12.78,0,0,0-9.63-4,13.92,13.92,0,0,0-10,4,14.48,14.48,0,0,0,0,20,13.92,13.92,0,0,0,10,4A12.78,12.78,0,0,0,492,114.8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.62,128.79a21.76,21.76,0,0,1-16.35-6.9,23.52,23.52,0,0,1-6.54-17,23.9,23.9,0,0,1,6.54-17.08,21.76,21.76,0,0,1,16.35-6.9c7.27,0,12.54,2.36,15.72,7.18.45-2.36,1.72,2.82,3.72,1.46,1.64-1-1.27-.46,1.36-.46,2.36,0-.82.28.36.73l3,.81a8.49,8.49,0,0,0-1.27-.18c-2.45,0,2.64,1.45,2.64,5.36v32h-10.9v-6.63C437.52,125.52,432,128.79,424.62,128.79Zm1.46-37.88a13.16,13.16,0,0,0-9.72,4,15,15,0,0,0,0,20,13.12,13.12,0,0,0,9.72,4,13.56,13.56,0,0,0,9.9-4,14.25,14.25,0,0,0,0-20A13.6,13.6,0,0,0,426.08,90.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.41,149.08l-2.19,2.49a5.89,5.89,0,0,0-4.4-1.91c-1.71,0-2.57.6-2.57,1.8a1.51,1.51,0,0,0,.56,1.2,7,7,0,0,0,1.93,1l1.8.73a11.6,11.6,0,0,1,3.91,2.39,4.55,4.55,0,0,1,1.22,3.28,5,5,0,0,1-2,4.23,8,8,0,0,1-5,1.51,9,9,0,0,1-7.58-3.64l2.3-2.53a7.39,7.39,0,0,0,5.28,2.69,4,4,0,0,0,2.17-.54,1.75,1.75,0,0,0,.86-1.57,1.51,1.51,0,0,0-.63-1.3,10.51,10.51,0,0,0-2-1l-1.92-.8a11.1,11.1,0,0,1-3.69-2.26,4.38,4.38,0,0,1-1.21-3.22,4.75,4.75,0,0,1,1.88-4,7.51,7.51,0,0,1,4.75-1.46A8.1,8.1,0,0,1,164.41,149.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.87,149a9.78,9.78,0,0,1,0,14,10.13,10.13,0,0,1-14.11,0,9.9,9.9,0,0,1,0-13.94,9.65,9.65,0,0,1,7.05-2.84A9.78,9.78,0,0,1,185.87,149Zm-11.22,2.62a6.6,6.6,0,0,0,0,8.73,5.86,5.86,0,0,0,8.35,0,6,6,0,0,0,1.69-4.34,6.09,6.09,0,0,0-1.67-4.39,5.65,5.65,0,0,0-4.15-1.78A5.71,5.71,0,0,0,174.65,151.63Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.19,165.4h-4V136.67h4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221,157.51a8.06,8.06,0,0,1-2.32,6,8,8,0,0,1-5.84,2.28,7.9,7.9,0,0,1-8.23-8.31V146.59h4v11.23a4.13,4.13,0,0,0,1.21,3.12,4.19,4.19,0,0,0,3,1.17,4,4,0,0,0,3-1.17,4.19,4.19,0,0,0,1.19-3.12V146.59h4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.56,162v3.41a15.9,15.9,0,0,1-3.33.42,7.38,7.38,0,0,1-5.09-1.63,6.2,6.2,0,0,1-1.84-4.92v-9.19h-3.07v-3.49h3.07v-4.94h4.06v4.94H238v3.49h-5.59v8.85a3,3,0,0,0,.94,2.52,4.42,4.42,0,0,0,2.77.73A22.86,22.86,0,0,0,238.56,162Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.33,137.69a2.53,2.53,0,0,1,.81,1.9,2.47,2.47,0,0,1-.81,1.87,2.67,2.67,0,0,1-1.91.77,2.71,2.71,0,0,1-1.95-.77,2.47,2.47,0,0,1-.81-1.87,2.53,2.53,0,0,1,.81-1.9,2.69,2.69,0,0,1,1.95-.79A2.64,2.64,0,0,1,247.33,137.69Zm.08,27.71h-4V146.59h4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.8,149a9.78,9.78,0,0,1,0,14,10.14,10.14,0,0,1-14.12,0,9.9,9.9,0,0,1,0-13.94,9.67,9.67,0,0,1,7.05-2.84A9.81,9.81,0,0,1,269.8,149Zm-11.22,2.62a6.57,6.57,0,0,0,0,8.73,5.49,5.49,0,0,0,4.17,1.75,5.61,5.61,0,0,0,4.18-1.75,6,6,0,0,0,1.68-4.34,6.09,6.09,0,0,0-1.66-4.39,5.79,5.79,0,0,0-8.35,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.65,148.22a7.72,7.72,0,0,1,1.87,5.42V165.4h-4V154.18a4.45,4.45,0,0,0-1.13-3.16,3.85,3.85,0,0,0-3-1.21,4.12,4.12,0,0,0-3.08,1.23,4.29,4.29,0,0,0-1.21,3.14V165.4h-4V146.59h3.76v1.88a7.27,7.27,0,0,1,5.63-2.3A6.7,6.7,0,0,1,292.65,148.22Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.41,149.08l-2.19,2.49a5.89,5.89,0,0,0-4.4-1.91c-1.71,0-2.57.6-2.57,1.8a1.51,1.51,0,0,0,.56,1.2,7,7,0,0,0,1.93,1l1.8.73a11.6,11.6,0,0,1,3.91,2.39,4.55,4.55,0,0,1,1.22,3.28,5,5,0,0,1-2,4.23,8,8,0,0,1-5,1.51,9,9,0,0,1-7.58-3.64l2.3-2.53a7.39,7.39,0,0,0,5.28,2.69,4,4,0,0,0,2.17-.54,1.75,1.75,0,0,0,.86-1.57,1.51,1.51,0,0,0-.63-1.3,10.51,10.51,0,0,0-2-1l-1.92-.8a11.1,11.1,0,0,1-3.69-2.26,4.38,4.38,0,0,1-1.21-3.22,4.77,4.77,0,0,1,1.88-4,7.51,7.51,0,0,1,4.75-1.46A8.1,8.1,0,0,1,313.41,149.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofull);
export default __webpack_public_path__ + "static/media/logofull.04215a82f8d49b8c4fbd3893ab2ade07.svg";
export { ForwardRef as ReactComponent };